import { PaymentTerm } from '@cemex-core/cmx-api';
import { OneClickPaymentsActions, OneClickPaymentsActionTypes } from '../actions/one-click-payments.actions';
import { OneClickProfileActions, OneClickProfileActionTypes } from '../actions/one-click-profile.actions';

export interface OneClickPaymentsState {
  loading: boolean[];
  paymentsAvailable: PaymentTerm[][];
  selected: PaymentTerm[];
}

export const initialState: OneClickPaymentsState = {
  loading: [],
  paymentsAvailable: [],
  selected: [],
};

export function reducer(
  state = initialState,
  action: OneClickPaymentsActions | OneClickProfileActions,
): OneClickPaymentsState {
  switch (action.type) {
    case OneClickPaymentsActionTypes.LOAD_PAYMENTS: {
      return {
        ...state,
        loading: state.loading.map(() => true),
      };
    }
    case OneClickPaymentsActionTypes.LOAD_PAYMENTS_BUILDER_PRODUCT: {
      state.loading[action.index] = true;
      return {
        ...state,
        loading: state.loading.map((item, index) => {
          if (index === action.index) {
            return true;
          } else {
            return item;
          }
        }),
      } as OneClickPaymentsState;
    }
    case OneClickPaymentsActionTypes.LOAD_PAYMENTS_COMPLETE: {
      state.loading[action.index] = true;
      state.paymentsAvailable[action.index] = undefined;
      return {
        ...state,
        loading: state.loading.map((item, index) => {
          if (index === action.index) {
            return false;
          } else {
            return item;
          }
        }),
        paymentsAvailable: state.paymentsAvailable.map((item, index) => {
          if (index === action.index) {
            return [...action.payload];
          } else {
            return item;
          }
        }),
      } as OneClickPaymentsState;
    }
    case OneClickPaymentsActionTypes.SELECT_PAYMENT: {
      state.selected[action.index] = undefined;
      return {
        ...state,
        selected: state.selected.map((item, index) => {
          if (index === action.index) {
            return action.payload;
          } else {
            return item;
          }
        }),
      } as OneClickPaymentsState;
    }
    case OneClickProfileActionTypes.RESET_BUILDER:
    case OneClickPaymentsActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
